import { render, staticRenderFns } from "./CompletedCoursesTab.vue?vue&type=template&id=d01848d6&"
import script from "./CompletedCoursesTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CompletedCoursesTab.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports